import React from "react";
import { TeachingBubble } from "@fluentui/react/lib/TeachingBubble";

import { ITeachProps } from "./ITeachProps";
import { WithTranslator } from "../Translator";
import { useTeach } from "./UseTeach";

export const Teach = WithTranslator((props: ITeachProps): JSX.Element => {
  const {
    id, show, token, translator
  } = props;

  const { showTeach, onHide, onDismiss } = useTeach(token, show);

  if (!showTeach) {
    return null;
  }

  return (
    <TeachingBubble
      target={`#${id}`}
      hasCloseButton
      onDismiss={onDismiss}
      hasCondensedHeadline
      headline={`${translator.get(`${token}.headline`, `~missing teach headline~`)}...`}
      primaryButtonProps={{
        text: translator.get(`generic.donotshowagain`, `Don't show again`),
        onClick: onHide
      }}
      calloutProps={{
        directionalHint: 10,
        dismissOnTargetClick: true,
        setInitialFocus: true
      }}
    >
      {translator.get(`${token}.text`, `~missing teach text~`)}
    </TeachingBubble>
  );
});
